export const FEATURE_NAME = 'TypologyChest';
